import { Component, Input } from '@angular/core';

@Component({
  selector: 'terms-and-conditions-consent-list-view',
  templateUrl: './terms-and-conditions-consent-list-view.component.html',
  styleUrl: './terms-and-conditions-consent-list-view.component.scss',
  standalone: false,
})
export class TermsAndConditionsConsentListViewComponent {
  @Input() cookies: app.models.CookieConsentDetailsModel[];
  @Input() props: app.models.DynamicPropsDictionary;
}
